const SIGNATURES = [
  'ResizeObserver loop completed with undelivered notifications',
  'ResizeObserver loop limit exceeded',
];

const matchesSignature = (text) =>
  typeof text === 'string' && SIGNATURES.some((sig) => text.indexOf(sig) !== -1);

export const isResizeObserverNoise = (event) => {
  if (!event || !Array.isArray(event.errors) || event.errors.length === 0) {
    return false;
  }
  const err = event.errors[0];
  return matchesSignature(err?.errorMessage);
};

export const dropResizeObserverNoise = (event) => {
  if (isResizeObserverNoise(event)) return false;
  return undefined;
};

export const installResizeObserverConsoleFilter = (target) => {
  const win = target || (typeof window !== 'undefined' ? window : null);
  if (!win || win.__resizeObserverFilterInstalled) return () => {};
  win.__resizeObserverFilterInstalled = true;

  const handleErrorEvent = (event) => {
    if (!event) return;
    if (matchesSignature(event.message) || matchesSignature(event.error?.message)) {
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      if (typeof event.preventDefault === 'function') {
        event.preventDefault();
      }
    }
  };

  win.addEventListener('error', handleErrorEvent, true);

  const originalConsoleError =
    win.console && typeof win.console.error === 'function'
      ? win.console.error
      : null;
  if (originalConsoleError) {
    win.console.error = (...args) => {
      if (args.some((a) => matchesSignature(a) || matchesSignature(a?.message))) {
        return;
      }
      originalConsoleError.apply(win.console, args);
    };
  }

  return () => {
    win.removeEventListener('error', handleErrorEvent, true);
    if (originalConsoleError) {
      win.console.error = originalConsoleError;
    }
    delete win.__resizeObserverFilterInstalled;
  };
};

export default dropResizeObserverNoise;
